import React, { useState, useEffect } from "react";
import { FaChevronUp } from "react-icons/fa";
import "./wpIcon.css"
import { FaWhatsapp } from "react-icons/fa6";

const WpButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 560) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-[105px] right-4 z-50">
      {isVisible && (
                <a  href={`https://wa.link/bpbu0g`} target="_blank" rel="noopener noreferrer" >
                  <div className="wp-button"><FaWhatsapp /></div>
                  </a>
      )}
    </div>
  );
};

export default WpButton;
